import type { ComponentType } from 'react';
import BirdIconSvg from './BirdIconSvg';
import { getBirdIconDef } from './registry';

export type HeroiconComponent = ComponentType<{ className?: string }>;

export function createBirdHeroicon(name: string, solid = false): HeroiconComponent {
  function Icon({ className }: { className?: string }) {
    return <BirdIconSvg def={getBirdIconDef(name, solid)} className={className} animated />;
  }
  Icon.displayName = name;
  return Icon;
}
